import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { Router } from '@angular/router';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';

const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

interface Employee {
  id: number;
  first_name: string;
  last_name: string;
}

interface AttendanceRecord {
  employee_id: number;
  attendance_date: string;
  status: string;
  actual_in_time?: string;
  actual_out_time?: string;
  notes?: string;
}

@Component({
  selector: 'app-daily-attendance',
  templateUrl: './daily-attendance.component.html',
  styleUrls: ['./daily-attendance.component.css']
})
export class DailyAttendanceComponent implements OnInit {
  employees: Employee[] = [];
  selectedDate: any;
  attendanceRecords: any = [];
  showTimeModal: boolean = false;
  selectedEmployee: Employee | null = null;
  selectedStatus: string = '';
  inTime: string = '';
  outTime: string = '';
  rosterMap: any = {};   // will store roster for each employee

  currentUser: any = {};
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };

  constructor(private loginService: LoginService, private router: Router) { }

  ngOnInit() {
    this.selectedDate = this.formatDateForPicker(new Date());
    this.currentUser = JSON.parse(this.loginService.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('36');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }
    this.loadEmployees();
    this.loadAttendance();
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      return false;
    }
  }

  getrosterdetails(emp_id) {
    const empRoster = this.rosterMap ? this.rosterMap[emp_id] : null;
    if (!empRoster || !empRoster.type) {
      return 'Roster Not Configured';
    }
    const type = empRoster.type.toLowerCase();
    switch (type) {
      case 'week_off':
      case 'weekoff':
      case 'wo':
        return "Assigned Roster: WEEK OFF";

      case 'outdoor':
      case 'outdoor_duty':
      case 'od':
        return "Assigned Roster: OUTDOOR DUTY → " +
          this.formatTo12Hour(empRoster.in_time) + " - " +
          this.formatTo12Hour(empRoster.out_time);

      case 'permission':
      case 'perm':
        return "Assigned Roster: PERMISSION → " +
          this.formatTo12Hour(empRoster.in_time) + " - " +
          this.formatTo12Hour(empRoster.out_time);

      case 'leave':
      case 'lv':
        return "Assigned Roster: LEAVE";

      case 'holiday':
        return "Assigned Roster: HOLIDAY";

      case 'present':
      case 'working':
        return "Assigned Roster: Working → " +
          this.formatTo12Hour(empRoster.in_time) + " - " +
          this.formatTo12Hour(empRoster.out_time);

      default:
        return "default: " + empRoster.type;
    }
  }


  getrosterdetailsText(emp_id) {
    const empRoster = this.rosterMap ? this.rosterMap[emp_id] : null;
    if (!empRoster || !empRoster.type) {
      return 'Roster Not Configured';
    }
    const type = empRoster.type.toLowerCase();
    switch (type) {
      case 'week_off':
      case 'weekoff':
      case 'wo':
        return "weekoffText";

      case 'outdoor':
      case 'outdoor_duty':
      case 'od':
        return "outdoor_dutyText"

      case 'permission':
      case 'perm':
        return "permissionText"

      case 'leave':
      case 'lv':
        return "leaveText";

      case 'holiday':
        return "holidayText";

      case 'present':
      case 'working':
        return "presentText"

      default:
        return "default: " + empRoster.type;
    }
  }


  formatTo12Hour(time: string): string {
    if (!time) return '';
    let [hour, minute] = time.split(':').map(Number);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    hour = hour ? hour : 12; // 0 → 12
    return `${hour}:${minute.toString().padStart(2, '0')} ${ampm}`;
  }

  loadRosterForSelectedDate() {
    const date = this.formatYMD(this.selectedDate);
    this.employees.forEach(emp => {
      this.loginService.getRosterByDate({
        employee_id: emp.id,
        date: date,
        salon_id: this.currentUser.salon_id
      }).subscribe((res: any) => {
        if (res.status === "success") {
          this.rosterMap[emp.id] = res.roster;
        } else {
          this.rosterMap[emp.id] = null;
        }
      }, error => { alert('Network Error getRosterByDate API'); });

    });
  }


  loadEmployees() {
    this.loginService.getEmployeesForAttendance(this.currentUser).subscribe(
      (response: any) => {
        this.employees = response.employees || [];
        // ✅ Now employees array has actual data
        this.loadRosterForSelectedDate();
      },
      error => {
        alert('Network Error getEmployeesForAttendance API');
        console.error('Error loading employees:', error);
      }
    );
  }


  loadAttendance() {
    this.showTimeModal = false;
    this.loginService.getDailyAttendance({
      date_from: this.formatYMD(this.selectedDate),
      date_to: this.formatYMD(this.selectedDate),
      salon_id: this.currentUser.salon_id
    }).subscribe(
      (response: any) => {
        this.attendanceRecords = response.attendance || [];
      },
      error => {
        alert('Network Error getDailyAttendance API');
        console.error('Error loading attendance:', error);
      }
    );
  }

  // markAttendance(employee: Employee, status: string) {
  //   this.showTimeModal = false;
  //   // Reset the previous values (very important)
  //   this.inTime = '';
  //   this.outTime = '';
  //   if (['present', 'permission', 'on_duty', 'outdoor_duty'].includes(status)) {
  //     this.selectedEmployee = employee;
  //     this.selectedStatus = status;
  //     const rec = this.attendanceRecords.find(r => r.employee_id === employee.id);
  //     // If record exists → load times, else keep empty
  //     this.inTime = rec && rec.actual_in_time ? rec.actual_in_time.substring(0, 5) : '';
  //     this.outTime = rec && rec.actual_out_time ? rec.actual_out_time.substring(0, 5) : '';

  //     this.showTimeModal = true;
  //     return;
  //   }
  //   // For absent/week_off
  //   const attendance = {
  //     employee_id: employee.id,
  //     attendance_date: this.formatDate1(this.selectedDate),
  //     status: status,
  //     created_by: 1
  //   };

  //   this.loginService.markAttendance({ attendance }).subscribe(
  //     () => this.loadAttendance()
  //   );
  // }


  markAttendance(employee: Employee, status: string) {
    const roster = this.rosterMap && this.rosterMap[employee.id];
    if (!roster) {
      alert("Roster not set for this employee. Please update Weekly Roster first.");
      return;
    }
    if (roster.type === '') {
      alert("Roster not set for this employee. Please update Weekly Roster first.");
      return;
    }

    // if (roster.type !== status) {
    //   alert("This day is a " + roster.type + " in roster. Change roster first.");
    //   return;
    // }
    // if (roster.type === 'week_off') {
    //   alert("This day is a WEEK OFF in roster. Change roster first.");
    //   return;
    // }
    // if (roster.type === 'leave') {
    //   alert("This day is marked as LEAVE in roster. Modify roster first.");
    //   return;
    // }

    this.showTimeModal = false;
    const rec = this.attendanceRecords.find(r => r.employee_id === employee.id);
    this.selectedEmployee = employee;
    this.selectedStatus = status;
    const timeStatuses = ['working', 'permission', 'outdoor_duty'];
    // 🟡 If the status needs IN/OUT time modal
    if (timeStatuses.includes(status)) {
      // ---- CASE 1 ----
      // If clicked SAME status → restore saved time
      if (rec && rec.status === status) {
        this.inTime = rec.actual_in_time ? rec.actual_in_time.substring(0, 5) : '';
        this.outTime = rec.actual_out_time ? rec.actual_out_time.substring(0, 5) : '';
      }
      // ---- CASE 2 ----
      // If clicked DIFFERENT status → clear time input
      else {
        this.inTime = '';
        this.outTime = '';
      }
      this.showTimeModal = true;
      return;
    }
    // 🟥 Non-time statuses (absent, week_off, holiday)
    const attendance = {
      employee_id: employee.id,
      attendance_date: this.formatYMD(this.selectedDate),
      status: status,
      created_by: 1,
      salon_id: this.currentUser.salon_id
    };
    this.loginService.markAttendance({ attendance }).subscribe(() => {
      this.loadAttendance();
    }, error => { alert('Network Error markAttendance API'); });
  }


  saveAttendanceWithTime() {
    if (!this.inTime) {
      alert('In time is required');
      return;
    }
    const statusNeedsOut = ['working', 'permission', 'on_duty', 'outdoor_duty'];
    let attendance: any = {
      employee_id: this.selectedEmployee!.id,
      attendance_date: this.formatYMD(this.selectedDate),
      status: this.selectedStatus,
      actual_in_time: this.inTime,
      created_by: 1,
      salon_id: this.currentUser.salon_id
    };
    // Handle OUT time for statuses that require it
    if (statusNeedsOut.includes(this.selectedStatus)) {
      if (this.outTime) {
        attendance.actual_out_time = this.outTime;
      } else {
        // attendance.status = 'pending';   // mark as pending
      }
    }
    this.loginService.markAttendance({ attendance }).subscribe(
      () => {
        this.loadAttendance();
        this.showTimeModal = false;
      },
      error => {
        alert('Network Error markAttendance API');
        console.error('Error marking attendance:', error);
      }
    );
  }

  cancelTimeInput() {
    this.showTimeModal = false;
    this.selectedEmployee = null;
    this.selectedStatus = '';
    this.inTime = '';
    this.outTime = '';
  }


  getAttendanceStatus(employeeId: number): string {
    const record = this.attendanceRecords.find(r => r.employee_id === employeeId);
    if (!record) return 'status-not-marked';

    const status = record.status ? record.status.trim() : '';
    const inTime = record.actual_in_time ? record.actual_in_time.trim() : '';
    const outTime = record.actual_out_time ? record.actual_out_time.trim() : '';
    const isOutTimeEmpty =
      outTime === '' || outTime === '00:00:00' || outTime === null;
    if (inTime !== '' && isOutTimeEmpty && status !== 'absent' && status !== 'week_off' && status !== 'holiday') {
      return 'status-pending';
    }
    return 'status-' + status;
  }

  // getAttendanceStatusText(employeeId: number): string {
  //   const record = this.attendanceRecords.find(r => r.employee_id === employeeId);
  //   return record ? record.status.toUpperCase() : 'NOT MARKED';
  // }

  // getAttendanceStatusText(employeeId: number): string {

  //   const record = this.attendanceRecords.find(r => r.employee_id === employeeId);

  //   if (!record) return 'NOT MARKED';
  //   const status = record.status ? record.status.trim() : '';
  //   const inTime = record.actual_in_time ? record.actual_in_time.trim() : '';
  //   const outTime = record.actual_out_time ? record.actual_out_time.trim() : '';
  //   const isOutTimeEmpty =
  //     outTime === '' || outTime === '00:00:00' || outTime === null;
  //   // handle pending out time
  //   if (inTime !== '' && isOutTimeEmpty && status !== 'absent' && status !== 'week_off' && status !== 'holiday') {
  //     const text = record.status_text ? ` (${record.status_text.toUpperCase()}) ` : '';
  //     return text + '  (OUT TIME PENDING)';
  //   }
  //   return status.toUpperCase();
  // }

  getAttendanceStatusText(employeeId: number): string {
    const record = this.attendanceRecords.find(r => r.employee_id === employeeId);

    if (!record) return 'ATTENDANCE NOT MARKED';

    const rawStatus = record.status ? record.status.trim().toUpperCase() : '';
    let status = rawStatus;

    // Convert WORKING → PRESENT
    if (status === 'WORKING') {
      status = 'PRESENT';
    }

    // Convert times to 12-hour format
    const inTime = record.actual_in_time
      ? this.formatTo12Hour(record.actual_in_time.substring(0, 5))
      : '--';

    const outTime = record.actual_out_time
      ? this.formatTo12Hour(record.actual_out_time.substring(0, 5))
      : '--';

    const isOutTimeEmpty =
      !record.actual_out_time ||
      record.actual_out_time === '' ||
      record.actual_out_time === '00:00:00';

    // No time needed for these statuses
    const noTimeStatuses = ['ABSENT', 'WEEK_OFF', 'HOLIDAY'];

    if (noTimeStatuses.indexOf(status) !== -1) {
      return status;
    }

    // OUT TIME PENDING
    if (inTime !== '--' && isOutTimeEmpty) {
      const text = record.status_text
        ? record.status_text.toUpperCase()
        : status;

      const finalText = text === 'WORKING' ? 'PRESENT' : text;

      return `${finalText} (${inTime} — ??) OUT TIME PENDING`;
    }

    // Normal display
    return `${status} (${inTime} — ${outTime})`;
  }


  getWeekNumber(dateString: string): number {
    const date = new Date(dateString);
    // Copy date so original is not modified
    const tempDate: any = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    // Set to nearest Thursday (ISO week rule)
    const dayNum = tempDate.getUTCDay() || 7;
    tempDate.setUTCDate(tempDate.getUTCDate() + 4 - dayNum);
    // Start of the year
    const yearStart: any = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
    // Calculate week number
    const week = Math.ceil((((tempDate - yearStart) / 86400000) + 1) / 7);
    return week;
  }

  getWeekDetails(sel: any) {
    if (!sel) return null;

    const date = new Date(sel);

    if (isNaN(date.getTime())) return null;

    // --- ISO Week Calculation ---
    const temp = new Date(date.getTime());
    const dayNum = (date.getDay() + 6) % 7; // Monday = 0
    temp.setDate(temp.getDate() - dayNum + 3); // Thursday of this week

    const firstThursday = new Date(temp.getFullYear(), 0, 4);
    const week =
      1 +
      Math.round(
        ((temp.getTime() - firstThursday.getTime()) / 86400000 -
          3 +
          ((firstThursday.getDay() + 6) % 7)) /
        7
      );

    const year = temp.getFullYear();

    // --- Calculate Monday and Sunday ---
    const monday = new Date(date);
    monday.setDate(date.getDate() - dayNum);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    const format = (d: Date) =>
      d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

    return {
      week,
      year,
      monday: format(monday),
      sunday: format(sunday),
    };
  }


  formatDate(date: string): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  formatDate1(date: string): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  }

  onDateChanged(type, event: IMyDateModel): void {
    this.selectedDate = event;
    this.loadAttendance();
    this.loadRosterForSelectedDate();
  }

  formatDateForPicker(dateObj: Date) {
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    return {
      date: { year: year, month: month, day: day },
      jsdate: dateObj.toISOString(),
      formatted: this.formatDDMMYYYY(day, month, year),
      epoc: Math.floor(dateObj.getTime() / 1000)
    };
  }

  formatDDMMYYYY(day: number, month: number, year: number): string {
    return this.pad(day) + '/' + this.pad(month) + '/' + year;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  formatYMD(obj) {
    const d = obj.date;
    return `${d.year}-${('0' + d.month).slice(-2)}-${('0' + d.day).slice(-2)}`;
  }

}


// WEBPACK FOOTER //
// ./src/app/daily-attendance/daily-attendance.component.ts